import { memo } from "react";

import { Typography } from "@bigbinary/neeto-atoms";
import PropTypes from "prop-types";

import "./page-loader.css";

const PageLoader = ({ text = "", ...otherProps }) => (
  <div
    className="relative box-border h-full w-full [&_*]:box-border"
    {...otherProps}
  >
    <div className="inset-inline-start-0 absolute top-0 flex h-full w-full flex-col items-center justify-center">
      <div
        className="relative mb-4 flex shrink-0 items-center justify-center p-2"
        data-testid="neeto-molecules-pageloader"
      >
        <div className="neeto-molecules-pageloader__loader" />
      </div>
      {text && (
        <Typography variant="h5" weight="semibold">
          {text}
        </Typography>
      )}
    </div>
  </div>
);

PageLoader.propTypes = { text: PropTypes.string };

export default memo(PageLoader);
